import { avatarDomain } from '@trello/config';

export interface Avatars {
  [size: string]: string;
}

export function avatarsFromAvatarHash(avatarHash: string): Avatars {
  return ['30', '50', '170', 'original'].reduce((avatars: Avatars, size) => {
    avatars[size] = `${avatarDomain}/${avatarHash}/${size}.png`;
    return avatars;
  }, {});
}

export function avatarsFromAvatarUrl(avatarUrl: string): Avatars {
  return ['30', '50', '170', 'original'].reduce((avatars: Avatars, size) => {
    avatars[size] = `${avatarUrl}/${size}.png`;
    return avatars;
  }, {});
}
